var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"PublicPaap",staticStyle:{"padding":"0 1.75rem 0","background-color":"#fff","max-height":"90rem","overflow-y":"scroll"}},[(_vm.paapData)?_c('PaapViewer',{attrs:{"paap":_vm.paapData}}):_c('div',{staticStyle:{"text-align":"center","padding":"4rem 0"}},[_c('i',{staticClass:"fas fa-sync fa-spin fa-3x"})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }